module.exports = __webpack_public_path__ + "img/status-rank.470ab8a8.png";